import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import GeometrySnapper from './GeometrySnapper';
import System from '../../../../../../java/lang/System';
import CommonBitsRemover from '../../../precision/CommonBitsRemover';
import OverlayOp from '../OverlayOp';
var SnapOverlayOp = /*#__PURE__*/function () {
  function SnapOverlayOp() {
    _classCallCheck(this, SnapOverlayOp);
    SnapOverlayOp.constructor_.apply(this, arguments);
  }
  _createClass(SnapOverlayOp, [{
    key: "selfSnap",
    value: function selfSnap(geom) {
      var snapper0 = new GeometrySnapper(geom);
      var snapGeom = snapper0.snapTo(geom, this._snapTolerance);
      return snapGeom;
    }
  }, {
    key: "removeCommonBits",
    value: function removeCommonBits(geom) {
      this._cbr = new CommonBitsRemover();
      this._cbr.add(geom[0]);
      this._cbr.add(geom[1]);
      var remGeom = new Array(2).fill(null);
      remGeom[0] = this._cbr.removeCommonBits(geom[0].copy());
      remGeom[1] = this._cbr.removeCommonBits(geom[1].copy());
      return remGeom;
    }
  }, {
    key: "prepareResult",
    value: function prepareResult(geom) {
      this._cbr.addCommonBits(geom);
      return geom;
    }
  }, {
    key: "getResultGeometry",
    value: function getResultGeometry(opCode) {
      var prepGeom = this.snap(this._geom);
      var result = OverlayOp.overlayOp(prepGeom[0], prepGeom[1], opCode);
      return this.prepareResult(result);
    }
  }, {
    key: "checkValid",
    value: function checkValid(g) {
      if (!g.isValid()) System.out.println('Snapped geometry is invalid');
    }
  }, {
    key: "computeSnapTolerance",
    value: function computeSnapTolerance() {
      this._snapTolerance = GeometrySnapper.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
    }
  }, {
    key: "snap",
    value: function snap(geom) {
      var remGeom = this.removeCommonBits(geom);
      var snapGeom = GeometrySnapper.snap(remGeom[0], remGeom[1], this._snapTolerance);
      return snapGeom;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = new Array(2).fill(null);
      this._snapTolerance = null;
      this._cbr = null;
      var g1 = arguments[0],
        g2 = arguments[1];
      this._geom[0] = g1;
      this._geom[1] = g2;
      this.computeSnapTolerance();
    }
  }, {
    key: "overlayOp",
    value: function overlayOp(g0, g1, opCode) {
      var op = new SnapOverlayOp(g0, g1);
      return op.getResultGeometry(opCode);
    }
  }, {
    key: "union",
    value: function union(g0, g1) {
      return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.UNION);
    }
  }, {
    key: "intersection",
    value: function intersection(g0, g1) {
      return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.INTERSECTION);
    }
  }, {
    key: "symDifference",
    value: function symDifference(g0, g1) {
      return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.SYMDIFFERENCE);
    }
  }, {
    key: "difference",
    value: function difference(g0, g1) {
      return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.DIFFERENCE);
    }
  }]);
  return SnapOverlayOp;
}();
export { SnapOverlayOp as default };